import { render } from "./hosted-page.vue?vue&type=template&id=73ac3dfa"
import script from "./hosted-page.vue?vue&type=script&lang=js"
export * from "./hosted-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__